module.exports = __webpack_public_path__ + "img/icon-pause--green.570047a8.svg";